/*
 * @Author: 山白 geweijie@cai-inc.com
 * @Date: 2024-11-06 13:47:12
 * @LastEditors: 山白 geweijie@cai-inc.com
 * @LastEditTime: 2024-11-06 13:49:11
 * @FilePath: /zcy-claim-front/src/routes/TotalBudget/models/unitManage.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import unitManage from 'src/routes/Unit/models';

export default unitManage;
